import { ROUTE_APP_HOME, ROUTE_APP_LOGIN } from "../../constants/routes/app";
import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { AzurePrivateRoute } from "@pacificoseguros/security";
import Loading from "../../components/loading";

//import PrivateRoute from "../shared/private-router";

const Home = lazy(() => import("../home/home"));
const Login = lazy(() => import("../login/login"));

export const AppRoutes: React.FC = () => {
	return (
		<Suspense fallback={<Loading />}>
			<Switch>
				<Route exact path={ROUTE_APP_LOGIN} component={Login} />
				<AzurePrivateRoute path={ROUTE_APP_HOME} component={Home} />
			</Switch>
		</Suspense>
	);
};
